module.exports = __webpack_public_path__ + "static/img/body-bg.acc6a347.png";